import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import { useTranslation } from "react-i18next";
import Header from "../../layout/Header/Header";
import MenuBotones from "../../MenuBotones";

function BotonesAdmin() {
  const { user } = useContext(AuthContext);
  const [t] = useTranslation("global");

  if (!user.menuAdmin) return <Header />;

  return (
    <MenuBotones
      titulo={t("Admin")}
      descripcion={t("Cobranza y estados de cuenta de clientes")}
      icono="fas fa-file-invoice-dollar"
      color="#16a34a"
      secciones={[
        {
          section: t("Cobranza"),
          items: [
            { label: t("Abonos"), icon: "fas fa-hand-holding-usd", color: "#16a34a", href: "/ListadoAbonos",
              desc: t("Pagos recibidos de clientes"), enabled: !!user.menuAbonos },
            { label: t("Estado de Cuenta"), icon: "fas fa-file-invoice-dollar", color: "#2563eb", href: "/EstadoCuenta",
              desc: t("Cargos, pagos y saldo por cliente"), enabled: !!user.estadoCuentaClientes },
            { label: t("Estado de Cuenta ML"), icon: "fas fa-file-alt", color: "#7c3aed", href: "/EstadoCuentaML",
              desc: t("Estado de cuenta ML"), enabled: !!user.estadoCuentaML },
          ],
        },
      ]}
    />
  );
}

export default BotonesAdmin;
